import './Write.sass';

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRoute } from 'react-router5';

import { Header, Placeholder, ScrollView, SearchInput } from '$uikit';
import { imActions, imSelector } from '$store/im';
import { Loader } from '$shared/components';
import { WriteCell } from '$core/Write/WriteCell/WriteCell';
import router, { isBackNavigation } from '$navigation/router';
import { useTranslator } from '$hooks';
import { WriteProps } from './Write.interface';

export const Write: FC<WriteProps> = ({ onCellClick, onCloseButtonClick }) => {
  const dispatch = useDispatch();
  const { isWriteLoading, writeIds } = useSelector(imSelector);
  const { route } = useRoute();
  const isShare = !!route.params.share;
  const isBack = isBackNavigation();
  const [query, setQuery] = useState(route.params?.query ?? '');
  const t = useTranslator();

  useMemo(() => {
    if (!isBack) {
      dispatch(imActions.loadWrite());
    }
  }, []);

  useEffect(() => {
    const params: any = { ...route.params };
    if (query && query.length > 0) {
      if (params.query === query) {
        return;
      }

      params.query = query;
    } else {
      delete params.query;
    }

    router.navigate(route.name, params, { replace: true, urlParamsEncoding: false });

    let timer = setTimeout(() => {
      dispatch(imActions.loadWrite());
    }, 600);

    return () => {
      clearTimeout(timer);
    };
  }, [query]);

  const handleSearchChange = useCallback((newQuery) => {
    setQuery(newQuery);
  }, []);

  function renderContent() {
    if (isWriteLoading && !writeIds.length) {
      return <Loader isWrapped />;
    }

    if (!writeIds.length) {
      if (query.length > 0) {
        return <Placeholder centered>{t('search_not_found')}</Placeholder>;
      }

      return <Placeholder centered>{t('write_empty')}</Placeholder>;
    }

    return (
      <div className="Write__content">
        {writeIds.map((userId) => (
          <WriteCell key={userId} userId={userId} onClick={onCellClick} />
        ))}
      </div>
    );
  }

  return (
    <>
      <Header showCloseButton backButtonOnClick={onCloseButtonClick}>
        {t(isShare ? 'write_title_share' : 'write_title')}
      </Header>
      <ScrollView>
        <SearchInput
          query={query}
          onChange={handleSearchChange}
          placeholder={t('search')}
        />
        {renderContent()}
      </ScrollView>
    </>
  );
};
